import { create } from 'zustand';

export interface cartState {
    selectedItemIds: Set<string | number | bigint>;
    setSelectedById: (id: string | number | bigint) => void;
    clearCart: () => void;
}

export const cartStore = create<cartState>((set) => ({
    selectedItemIds: new Set<string>(),
    setSelectedById: (id: string | number | bigint) => {
        set((state) => {
            const newSelectedIds = new Set(state.selectedItemIds);

            if (newSelectedIds.has(id)) {
                newSelectedIds.delete(id);
            } else {
                newSelectedIds.add(id);
            }

            return { selectedItemIds: newSelectedIds };
        });
    },
    clearCart: () => {
        set(() => ({ selectedItemIds: new Set<string>() }));
    },
}));
